import React from "react";
import PropTypes from "prop-types";
import axios from "axios";

import Modal from "../../Modal";
import FormTemplate from "./Form";

class EditTemplate extends React.Component {
  state = {
    loading: false,
    messageType: "E-Mail",
    name: "",
    message: ""
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.dataEdit) {
      this.setState({
        messageType: nextProps.dataEdit.message_type,
        name: nextProps.dataEdit.name,
        message: nextProps.dataEdit.message
      });
    } else {
      this.resetState();
    }
  }

  render() {
    const { show, onClose } = this.props;
    const { messageType, name, message, loading } = this.state;

    return (
      <Modal title="Edit Template" visible={show} onClose={onClose}>
        <FormTemplate
          messageType={messageType}
          name={name}
          message={message}
          onChangeType={this.handlerChangeType}
          onChangeName={this.handlerChangeName}
          onChangeMessage={this.handlerChangeMessage}
        />

        <button
          type="button"
          className="btn btn-pink btn-block btn-raised"
          disabled={loading}
          onClick={this.handlerUpdate}
        >
          SAV{loading ? "ING..." : "E"}
        </button>
      </Modal>
    );
  }

  resetState = () =>
    this.setState({
      loading: false,
      messageType: "E-Mail",
      name: "",
      message: ""
    });

  handlerChangeType = messageType =>
    this.setState({ messageType: messageType });
  handlerChangeName = e => this.setState({ name: e.target.value });
  handlerChangeMessage = e => this.setState({ message: e.target.value });

  handlerUpdate = () => {
    this.setState({ loading: true });

    const { messageType, name, message } = this.state;

    axios
      .put(`/message_templates/${this.props.dataEdit.id}`, {
        message_type: messageType,
        name: name,
        message: message
      })
      .then(({ data }) => {
        toastr.success("Updated");
        this.resetState();
        this.props.onUpdated(data);
      })
      .catch(({ response }) => {
        if (response && response.data && response.data.message) {
          toastr.error(response.data.message.join("</br>"));
        }

        this.setState({ loading: false });
      });
  };
}

EditTemplate.propTypes = {
  show: PropTypes.bool,
  dataEdit: PropTypes.object,
  onClose: PropTypes.func,
  onUpdated: PropTypes.func
};

export default EditTemplate;
